/* unplugin-vue-components disabled */import script from "./Home.vue?vue&type=script&setup=true&lang=ts"
export * from "./Home.vue?vue&type=script&setup=true&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=2fe37818&lang=less&scoped=true"
import "./Home.vue?vue&type=style&index=1&id=2fe37818&lang=less"

import exportComponent from "E:\\guanwnag\\hzzn.group.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe37818"]])

export default __exports__